import {
    DEBIT_CREDIT_NOTE_REPORT_REQUEST,
    DEBIT_CREDIT_NOTE_REPORT_SUCCESS,
    DEBIT_CREDIT_NOTE_REPORT_FAILURE,
    GET_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_REQUEST,
    GET_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_SUCCESS,
    GET_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE,
    GET_DEBIT_CREDIT_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_REQUEST,
    GET_DEBIT_CREDIT_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_SUCCESS,
    GET_DEBIT_CREDIT_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE,
    GET_ITEMS_OF_DEBIT_CREDIT_NOTE_REQUEST,
    GET_ITEMS_OF_DEBIT_CREDIT_NOTE_SUCCESS,
    GET_ITEMS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE,
    GET_BROKERS_OF_DEBIT_CREDIT_NOTE_REQUEST,
    GET_BROKERS_OF_DEBIT_CREDIT_NOTE_SUCCESS,
    GET_BROKERS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE
  } from "../types/debit-credit-note-report-types";
  
  const initialState = {
    debitCreditNoteReport: {},
    accountsOfDebitCredit: {},
    debitCreditAccountsOfDebitCredit: {},
    itemsOfDebitCredit: {},
    brokersOfDebitCredit: {},
    loading: false,
    error: null,
  };
  
  const debitCreditNoteReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case DEBIT_CREDIT_NOTE_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case DEBIT_CREDIT_NOTE_REPORT_SUCCESS: {
        return {
          ...state,
          debitCreditNoteReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case DEBIT_CREDIT_NOTE_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      case GET_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case GET_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_SUCCESS: {
        return {
          ...state,
          accountsOfDebitCredit: { ...(action.payload || {}) },
          loading: false,
          error: null
        };
      }
      case GET_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      case GET_DEBIT_CREDIT_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case GET_DEBIT_CREDIT_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_SUCCESS: {
        return {
          ...state,
          debitCreditAccountsOfDebitCredit: { ...(action.payload || {}) },
          loading: false,
          error: null
        };
      }
      case GET_DEBIT_CREDIT_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      case GET_ITEMS_OF_DEBIT_CREDIT_NOTE_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case GET_ITEMS_OF_DEBIT_CREDIT_NOTE_SUCCESS: {
        return {
          ...state,
          itemsOfDebitCredit: { ...(action.payload || {}) },
          loading: false,
          error: null
        };
      }
      case GET_ITEMS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }

      case GET_BROKERS_OF_DEBIT_CREDIT_NOTE_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case GET_BROKERS_OF_DEBIT_CREDIT_NOTE_SUCCESS: {
        return {
          ...state,
          brokersOfDebitCredit: { ...(action.payload || {}) },
          loading: false,
          error: null
        };
      }
      case GET_BROKERS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default debitCreditNoteReportReducer;
  